module.exports = __webpack_public_path__ + "img/fossilImg4.b97285cb.jpg";